export type WindowEvents = {
    'General.Window.RELOAD': void;
    'General.Window.OPEN_CASHIER': void;
    'General.Window.OPEN_HISTORY': void;
    'General.Window.GO_TO_HOME': void;
    'General.Window.QUIT': void;
};